import React from 'react';
import { motion } from 'framer-motion';
export function PlatformInstitutional() {
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-418">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-419">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-420">
          <div className="mb-6" data-id="element-421">
            <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em]" data-id="element-422">
              Why the Platform Matters
            </span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-ink-dark leading-tight mb-8 text-balance" data-id="element-423">
            A stronger human layer creates stronger institutions
          </h2>

          <div className="space-y-6 text-lg text-ink-muted leading-relaxed" data-id="element-424">
            <p data-id="element-425">
              A society can possess technology, infrastructure, formal rules,
              and well-funded systems, yet still weaken if too many important
              decisions are shaped by poor reasoning, emotional reactivity,
              manipulation, weak foresight, or degraded leadership. Institutions
              are only as strong as the judgment of the people operating inside
              them.
            </p>
            <p data-id="element-426">
              That is why the SyNeural platform is built to function across both
              the individual and institutional levels. It helps identify where
              capability is strong, where it is weak, where support systems are
              missing, and where development pathways can strengthen performance
              over time.
            </p>
            <p className="font-medium text-navy" data-id="element-427">
              At scale, this gives organizations and governments a more useful
              foundation for building resilient communities, more competent
              institutions, and stronger leadership pipelines.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative h-full min-h-[400px] flex items-center justify-center bg-surface-muted rounded-2xl border border-line p-8" data-id="element-428">
          <svg viewBox="0 0 400 400" className="w-full h-full max-w-md" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-429">
            {/* Base Grid */}
            <g className="opacity-20" data-id="element-430">
              <path d="M 50 100 L 350 100 M 50 200 L 350 200 M 50 300 L 350 300" stroke="#123B5D" strokeWidth="1" strokeDasharray="4 4" data-id="element-431" />
              <path d="M 100 50 L 100 350 M 200 50 L 200 350 M 300 50 L 300 350" stroke="#123B5D" strokeWidth="1" strokeDasharray="4 4" data-id="element-432" />
            </g>

            {/* Abstract Institutional Structure */}
            <rect x="150" y="250" width="100" height="100" rx="8" fill="#FFFFFF" stroke="#245B8F" strokeWidth="2" data-id="element-433" />
            <rect x="100" y="150" width="80" height="80" rx="8" fill="#FFFFFF" stroke="#2E8C88" strokeWidth="2" data-id="element-434" />
            <rect x="220" y="150" width="80" height="80" rx="8" fill="#FFFFFF" stroke="#6FAE8A" strokeWidth="2" data-id="element-435" />
            <rect x="160" y="50" width="80" height="80" rx="8" fill="#123B5D" data-id="element-436" />

            {/* Connecting Pathways */}
            <path d="M 200 250 L 200 230 L 140 230 L 140 210" stroke="#D9E2EC" strokeWidth="3" data-id="element-437" />
            <path d="M 200 250 L 200 230 L 260 230 L 260 210" stroke="#D9E2EC" strokeWidth="3" data-id="element-438" />
            <path d="M 140 150 L 140 130 L 200 130 L 200 110" stroke="#D9E2EC" strokeWidth="3" data-id="element-439" />
            <path d="M 260 150 L 260 130 L 200 130 L 200 110" stroke="#D9E2EC" strokeWidth="3" data-id="element-440" />

            {/* Nodes */}
            <circle cx="200" cy="300" r="12" fill="#245B8F" data-id="element-441" />
            <circle cx="140" cy="190" r="10" fill="#2E8C88" data-id="element-442" />
            <circle cx="260" cy="190" r="10" fill="#6FAE8A" data-id="element-443" />
            <circle cx="200" cy="90" r="14" fill="#FFFFFF" data-id="element-444" />
            <circle cx="200" cy="90" r="6" fill="#123B5D" data-id="element-445" />
          </svg>
        </motion.div>
      </div>
    </section>;
}